import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'

@Component({
  selector: 'form-search',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
  ],
  templateUrl: './form-search.component.html',
  styleUrl: './form-search.component.scss',
})
export class FormSearchComponent implements OnInit, OnChanges {
  constructor(private formBuilder: FormBuilder) {}

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search: string = ''

  ngOnInit() {
    this.createForm()
  }

  ngOnChanges() {
    this.updateSearch()
  }

  updateSearch() {
    this.formSearch.get('search')?.setValue(this.search ?? '')
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      search: [''],
    })
  }

  sendSearch() {
    const search = this.formSearch.get('search')?.value.trim()
    this.responseSearch.emit(search)
  }

  checkSearch() {
    if (this.formSearch.get('search')!.value.trim().length > 0) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('search')?.value
    if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }
}
